'use strict'

import { debounce } from 'lodash'
import { getLang } from '../utils/utils'

const CLASS_ACTIV = 'activ'

const ID_QUERY_INPUT = 'js-inp-q'
const ID_AUTOCOMPLETE = 'js-autocomplete'
const ID_AUTOCOMPLETE_CAMPSITES = 'js-autocomplete-campsites'
const ID_AUTOCOMPLETE_CITIES = 'js-autocomplete-cities'
const ID_AUTOCOMPLETE_COUNTIES = 'js-autocomplete-counties'
const ID_AUTOCOMPLETE_DIVISIONS = 'js-autocomplete-divisions'

const SELECTOR_AUTOCOMPLETE = `#${ID_AUTOCOMPLETE}`

const AUTOCOMPLETE_MIN_LENGTH = 3
const AUTOCOMPLETE_DEBOUNCE = 250

const API_AUTOCOMPLETE = `${getLang()}/api/search/autocomplete`

export default {
  /**
   * @description Initialise search
   * @returns {undefined}
   */
  init() {
    this.bind()
  },

  /**
   * @description Bind events on search elements
   * @returns {undefined}
   */
  bind() {
    document.getElementById(ID_QUERY_INPUT)
            .bindEvent('input', debounce(() => this.getSuggestions(), AUTOCOMPLETE_DEBOUNCE))
    document.getElementById(ID_QUERY_INPUT).bindEvent('click', this.getSuggestions.bind(this))
    document.addEventListener('click', this.hideAutoComplete)
  },

  /**
   * @description if ID_QUERY_INPUT value length is at least AUTOCOMPLETE_MIN_LENGTH, fetch
   * data from API_AUTOCOMPLETE
   * @returns {undefined} none
   */
  getSuggestions() {
    const value = document.getElementById(ID_QUERY_INPUT).value
    if (value === this.query) {
      document.getElementById(ID_AUTOCOMPLETE).classList.add(CLASS_ACTIV)
      return
    }
    if (value.length < AUTOCOMPLETE_MIN_LENGTH) {
      document.getElementById(ID_AUTOCOMPLETE).classList.remove(CLASS_ACTIV)
      return
    }
    this.query = value
    fetch(`${API_AUTOCOMPLETE}?q=${this.query}`).then(response => {
      return response.json()
    }).catch(() => {}).then(json => {
      this.displayAutocomplete(json, value)
    }).catch(() => {})
  },

  /**
   * @description append lists to ID_AUTOCOMPLETE
   * @param {object} data API_AUTOCOMPLETE response
   * @param {string} value API_AUTOCOMPLETE query
   * @returns {undefined} none
   */
  displayAutocomplete(data, value) {
    const regex = new RegExp(`(${value})`, 'gi')
    const autocompleteContainer = document.getElementById(ID_AUTOCOMPLETE)
    const array = [{
      container: ID_AUTOCOMPLETE_CAMPSITES,
      data: data.campsites
    }, {
      container: ID_AUTOCOMPLETE_CITIES,
      data: data.suggests.cities
    }, {
      container: ID_AUTOCOMPLETE_DIVISIONS,
      data: data.suggests.divisions.concat(data.suggests.departments)
    }]

    array.map(obj => {
      const container = document.getElementById(obj.container)
      const list = container.querySelector('ul')
      if (list) {
        list.remove()
      }
      container.appendChild(this.createAutoCompleteList(obj.data, regex, obj.container))
    })
    autocompleteContainer.classList.add(CLASS_ACTIV)
  },

  /**
   * @description create and return lists
   * @param {object} data part of API_AUTOCOMPLETE response
   * @param {RegExp} regex highlight API_AUTOCOMPLETE query in suggestions
   * @returns {Element} list list of suggestions
   */
  createAutoCompleteList(data, regex, autocompleteContainerId = ID_AUTOCOMPLETE_CAMPSITES ) {
    const list = document.createElement('ul')
    data.forEach(item => {
      if (typeof item !== 'object' && !Object.keys(item).length) {
        return
      }
      const listItem = document.createElement('li')
      const link = document.createElement('a')
      let string = item.name
      let adminName =  item.admin_name ?  item.admin_name : null
      autocompleteContainerId !== ID_AUTOCOMPLETE_DIVISIONS && adminName !== null ? link.innerHTML = `<span class="green">${string} (${adminName})</span>`: link.innerHTML = string.replace(regex, `<span class="green">$1</span>`)
      link.href = item.url
      listItem.appendChild(link)
      list.appendChild(listItem)
    })
    return list
  },

  /**
   * @description hide autocomplete
   * @returns {undefined}
   */
  hideAutoComplete(e) {
    if (e && (e.target.id === ID_AUTOCOMPLETE
              || e.target.closest(SELECTOR_AUTOCOMPLETE)
              || e.target.id === ID_QUERY_INPUT)) {
      return
    }
    document.getElementById(ID_AUTOCOMPLETE).classList.remove(CLASS_ACTIV)
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/autocomplete.js